<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">付款日</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange" style="width: 280px;"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin: 0 5px;">缴费时间</span>
        <el-date-picker v-model="payTimevalue" size="small" type="daterange" style="width: 280px;"
                        :picker-options="pickerOptions3" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div style="display: flex;justify-content: space-between">
        <el-input placeholder="请输入内容" v-model="payDeadCount" size="small" style="width: 290px !important;" class="payDeadInput" type="number" @keyup.native.13="changePayDeadCount">
          <el-select v-model="payDeadStatus" slot="prepend" placeholder="请选择" class="prependSelect">
            <el-option label="逾期" value="1" />
            <el-option label="到期" value="2" />
          </el-select>
          <template slot="append">{{payDeadAppendText}}</template>
        </el-input>
        <input-search placeholder="住户名称/房间号" @search="searchKey" style="margin: 0 0 0 8px"/>
        <button-export
          :href="exportUrl"
          download="download.xls"
          style="margin: 0 0 0 8px"
          v-if="permissionCodes.indexOf('013003006') !== -1"
          :beforeDownload="beforeDownload"
          value="导出"/>
      </div>
    </div>
    <div class="search-line">
      <div class="btn-box">
        <input-select :selectTitle="'缴费渠道'" style="margin-right: 10px;" selectWidth="100px" :selectData="payChannelList" @search="search" :selectKey="'payChannel'" />
        <input-select :selectTitle="'缴费状态'" style="margin-right: 10px;" selectWidth="100px" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
        <input-select :selectTitle="'发票状态'" style="margin-right: 10px;" selectWidth="100px" :selectData="invoiceStatusList" @search="search" :selectKey="'invoiceStatus'" />
        <input-select :selectTitle="'账单类型'" style="margin-right: 10px;" selectWidth="100px" :selectData="billTypeList" @search="search" :selectKey="'billType'" />
        <input-select :selectTitle="'账单状态'" style="margin-right: 10px;" selectWidth="100px" :selectData="invalidStatusList" @search="search" :selectKey="'invalidStatus'" />
      </div>
      <div class="btn-box">
        <button-cancel value="批量修改发票状态" @cancel="updatePatchPayItemDetail" style="margin-left: 10px;" v-if="permissionCodes.indexOf('013003002') !== -1"/>
<!--        <button-cancel value="批量修改缴费状态" @cancel="batchPayStatus" style="margin-left: 10px;"  />-->
        <button-cancel value="批量修改免税状态" @cancel="batchUpdatePatchHsbz" style="margin-left: 10px;" v-if="permissionCodes.indexOf('013003004') !== -1"/>
        <button-cancel value="批量生成通知单" @cancel="batchDownloadNotice" style="margin-left: 10px;" v-if="permissionCodes.indexOf('013003007') !== -1" />
      </div>
    </div>
    <table-main :tableHead="tableHead" :tableWidth="'140%'" :tableData="tableData" @changeSwitch="changeSwitch" @separateAccounts="separateAccounts" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" :tableOperationWidth="'160px'" @changePagination="changePagination" :operationArr="operationArr" :operationFixed="'right'" />

    <el-dialog title="通知单模板选择" :visible.sync="noticeDialogFormVisible" width="500px" class="contractDialogForm"
               v-loading="downloadNoticeLoading"
               element-loading-text="通知单生成中，请耐心等待"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <div v-for="item in noticeTemplateList" class="contractDialogLine" :key="item.templateName">
          <div>{{item.templateName}}</div>
          <div class="operationBox">
            <span style="margin-right: 20px;" @click="previewContract(item.path, item.fileName, item.code)">预览</span>
            <span @click="downloadContract(item.path, item.fileName, item.code)">下载</span>
          </div>
        </div>
        <div v-if="noticeTemplateList.length === 0" style="text-align: center;line-height: 30px;">暂无通知单模板</div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="40%">
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费项：</span>
        </div>
        <el-input v-model="currentBillData.duration + currentBillData.feeType" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">应缴金额：</span>
        </div>
        <el-input v-model="currentBillData.payMoney" size="small" style="width: 280px" disabled >
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费住户：</span>
        </div>
        <el-input v-model="currentBillData.enterpriseName" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">分期数：</span>
        </div>
        <el-input v-model="splitAccountCount" size="small" style="width: 280px" />
      </div>
      <div v-for="(separateAccountItem, separateAccountIndex) in separateAccountData">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">{{separateAccountIndex + 1}}期金额：</span>
          </div>
          <el-input v-model="separateAccountItem.payMoney" size="small" style="width: 280px" >
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">{{separateAccountIndex + 1}}期截止时间：</span>
          </div>
          <el-date-picker v-model="separateAccountItem.payDeadline" type="date" size="small" value-format="yyyy-MM-dd" style="width: 280px" placeholder="选择日期"></el-date-picker>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelSplitAccount">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmSplitAccount">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Finance'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'rent-finance',
    data () {
      return {
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '账单管理'
        }],
        permissionCodes: '',
        timevalue: [],
        payTimevalue: [],
        pickerOptions2: {
          shortcuts: [{
            text: '未来一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        pickerOptions3: {
          shortcuts: [{
            text: '过去一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [{
          prop: 'contractCode',
          label: '合同编号',
          width: '120'
        }, {
          prop: 'enterpriseName',
          label: '住户名称',
          width: '180'
        }, {
          prop: 'roomInfoName',
          label: '房间号',
          width: '100'
        }, {
          prop: 'payMoneyText',
          label: '应缴金额(元)',
          width: '100'
        }, {
          prop: 'billType',
          label: '账单类型',
          width: '120'
        }, {
          prop: 'duration',
          label: '区间',
          width: '200'
        }, {
          prop: 'payDeadline',
          label: '付款日',
          width: '120'
        }, {
          prop: 'payDeadCountText',
          label: '到期时间',
          showColor: true,
          width: '120'
        }, {
          prop: 'payTime',
          label: '缴费时间',
          width: '180'
        }, {
          prop: 'payChannelText',
          label: '缴费渠道',
          width: '100'
        }, {
          prop: 'payStatusText',
          label: '缴费状态',
          width: '100'
        }, {
          prop: 'invoiceStatusText',
          label: '发票状态',
          width: '100'
        }, {
          prop: 'invalidStatusText',
          label: '账单状态',
          width: '100'
        }, {
          prop: 'hsbzState',
          label: '是否免税',
          isSwitch: true,
          width: '120'
        }],
        exportUrl: '',
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        payChannelList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '微信'
        }, {
          key: '2',
          label: '支付宝'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '现金'
        }, {
          key: '5',
          label: '其他'
        }],
        payStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未缴费'
        }, {
          key: '1',
          label: '已缴费'
        }, {
          key: '2',
          label: '部分缴费'
        }, {
          key: '3',
          label: '已缴费--变更'
        }, {
          key: '4',
          label: '未缴费--变更'
        }, {
          key: '5',
          label: '已退款'
        }, {
          key: '6',
          label: '审批中'
        }],
        invoiceStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未开票'
        }, {
          key: '1',
          label: '已开票'
        }, {
          key: '2',
          label: '开票中'
        }],
        invalidStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '正常'
        }, {
          key: '1',
          label: '已作废'
        }, {
          key: '2',
          label: '已退租'
        }],
        billTypeList: [],
        payDeadCount: '',
        payDeadStatus: '1',
        payDeadAppendText: '天外',
        requestData: {
          parentCode: '0',
          searchKey: '',
          payChannel: '',
          payStatus: '',
          invoiceStatus: '',
          invalidStatus: '',
          billType: '',
          feeType: '账单',
          overDayCount: '',
          payDeadCount: '',
          startTime: '',
          endTime: '',
          startPayTime: '',
          endPayTime: ''
        },
        wantModifyData: {},
        operationArr: ['modify'],

        downloadNoticeLoading: false,
        noticeDialogFormVisible: false,
        noticeTemplateList: [],
        currentDueOverData: {},

        currentBillData: {},
        dialogVisible: false,
        splitAccountCount: null,
        separateAccountData: [],
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getCreatTime()
      this.getBillTypeList()
    },
    activated() {
      this.getPage()
      this.getBillTypeList()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportOtherPayItemDetail}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&invoiceStatus=${this.requestData.invoiceStatus}&invalidStatus=${this.requestData.invalidStatus}&searchKey=${this.requestData.searchKey}&feeType=${this.requestData.feeType}&overDayCount=${this.requestData.overDayCount}&payDeadCount=${this.requestData.payDeadCount}&payChannel=${this.requestData.payChannel}&payStatus=${this.requestData.payStatus}&billType=${this.requestData.billType}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}&startPayTime=${this.requestData.startPayTime}&endPayTime=${this.requestData.endPayTime}`
      },
      getCreatTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        // this.timevalue[0] = year + '-' + month + '-01'
        // this.timevalue[1] = year + '-' + month + '-' + date
        // this.payTimevalue[0] = year + '-' + month + '-01'
        // this.payTimevalue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      getBillTypeList () {
        this.$axios.post(api.getOtherBillTypeList, {})
          .then(res => {
            let data = res.data.data || []
            data.map(v => {
              v.key = v.name
              v.label = v.name
            })
            data.unshift({
              key: '',
              label: '全部'
            })
            this.billTypeList = data
          })
          .catch(errorHandler("获取账单类型失败"));
      },
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || ''
          this.requestData.endTime = this.timevalue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        if (this.payTimevalue) {
          if (this.payTimevalue.length > 0) {
            this.requestData.startPayTime = `${this.payTimevalue[0]} 00:00:00`
            this.requestData.endPayTime = `${this.payTimevalue[1]} 23:59:59`
          } else {
            this.requestData.startPayTime = ''
            this.requestData.endPayTime = ''
          }
        } else {
          this.requestData.startPayTime = ''
          this.requestData.endPayTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getOtherPayItemDetailPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                v.children = v.childItems
                if (v.childItems) {
                  v.childItems.map(child => {
                    child.payMoneyText = child.payMoney + ''
                    child.childItems = []

                    if (child.payChannel === '1') {
                      child.payChannelText = '微信'
                    } else if (child.payChannel === '2') {
                      child.payChannelText = '支付宝'
                    } else if (child.payChannel === '3') {
                      child.payChannelText = '银行转账'
                    } else if (child.payChannel === '4') {
                      child.payChannelText = '现金'
                    } else if (child.payChannel === '5') {
                      child.payChannelText = '其他'
                    } else {
                      child.payChannelText = '--'
                    }
                    if (child.invoiceStatus === '0') {
                      child.invoiceStatusText = '未开票'
                    } else if (child.invoiceStatus === '1') {
                      child.invoiceStatusText = '已开票'
                    } else if (child.invoiceStatus === '2') {
                      child.invoiceStatusText = '开票中'
                    }
                    this.payStatusList.map(statusItem => {
                      if (child.payStatus === statusItem.key) {
                        child.payStatusText = statusItem.label
                      }
                    })
                    if (child.hsbz === '1') {
                      child.hsbzState = false
                    } else {
                      child.hsbzState = true
                    }
                    if (child.overDayCount) {
                      child.payDeadCountText = `已逾期${child.overDayCount}天`
                      child.fontColorToPeople = '#B22222'
                    } else if (child.payDeadCount) {
                      child.payDeadCountText = `${child.payDeadCount}天后到期`
                      child.fontColorToPeople = '#FF9933'
                    } else {
                      child.payDeadCountText = '--'
                    }
                  })
                }
                v.payMoneyText = v.payMoney + ''
                if (v.payChannel === '1') {
                  v.payChannelText = '微信'
                } else if (v.payChannel === '2') {
                  v.payChannelText = '支付宝'
                } else if (v.payChannel === '3') {
                  v.payChannelText = '银行转账'
                } else if (v.payChannel === '4') {
                  v.payChannelText = '现金'
                } else if (v.payChannel === '5') {
                  v.payChannelText = '其他'
                } else {
                  v.payChannelText = '--'
                }
                if (v.invoiceStatus === '0') {
                  v.invoiceStatusText = '未开票'
                } else if (v.invoiceStatus === '1') {
                  v.invoiceStatusText = '已开票'
                } else if (v.invoiceStatus === '2') {
                  v.invoiceStatusText = '开票中'
                }
                if (v.invalidStatus === '0') {
                  v.invalidStatusText = '正常'
                } else if (v.invalidStatus === '1') {
                  v.invalidStatusText = '已作废'
                } else if (v.invalidStatus === '2') {
                  v.invalidStatusText = '已退租'
                }
                this.payStatusList.map(statusItem => {
                  if (v.payStatus === statusItem.key) {
                    v.payStatusText = statusItem.label
                  }
                })
                if (v.hsbz === '1') {
                  v.hsbzState = false
                } else {
                  v.hsbzState = true
                }
                if (v.overDayCount) {
                  v.payDeadCountText = `已逾期${v.overDayCount}天`
                  v.fontColorToPeople = '#B22222'
                } else if (v.payDeadCount) {
                  v.payDeadCountText = `${v.payDeadCount}天后到期`
                  v.fontColorToPeople = '#FF9933'
                } else {
                  v.payDeadCountText = '--'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取账单信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePayDeadCount () {
        if (this.payDeadCount) {
          this.payDeadCount=this.payDeadCount.replace(/\D/g,'')
        }
        if (this.payDeadStatus === '1') {
          this.requestData.overDayCount = this.payDeadCount
          this.requestData.payDeadCount = ''
        } else {
          this.requestData.payDeadCount = this.payDeadCount
          this.requestData.overDayCount = ''
        }
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: `/other_rent_finance_modify/${code}`
        })
      },

      // 批量修改发票状态
      updatePatchPayItemDetail () {
        let reqData = []
        let sumMoney = 0
        this.selectionArr.map(selection => {
          this.tableData.map(v => {
            if (selection === v.code && v.invoiceStatus === '0') {
              for (let i in v) {
                if (v[i] === '--') {
                  v[i] = ''
                }
              }
              reqData.push(v)
              reqData[reqData.length - 1].invoiceStatus = '1'
              sumMoney = sumMoney + parseFloat(v.payMoney)
            }
          })
        })
        if (reqData.length === 0) {
          nError('请选择未开票的记录')
          return false
        }
        this.$confirm(`本次开票总金额为：${sumMoney.toFixed(2)} 元，已开票的不计入在内，请核对信息`, '温馨提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.updateOtherPayItemDetailPatch, reqData)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(() => {
                errorHandler('修改失败')
                this.getPage()
              })
          })
          .catch(() => {
            this.getPage()
          })
      },

      // 批量修改缴费状态
      batchPayStatus () {
        let reqData = []
        this.selectionArr.map(selection => {
          this.tableData.map(v => {
            if (selection === v.code && v.payStatus === '0') {
              for (let i in v) {
                if (v[i] === '--') {
                  v[i] = ''
                }
              }
              let obj = {
                code: v.code,
                payDeadline: v.payDeadline
              }
              reqData.push(obj)
            }
          })
        })
        if (reqData.length === 0) {
          nError('请选择未缴费的记录')
          return false
        }
        this.$confirm(`是否确认修改所选中的记录为已缴费`, '温馨提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.batchOtherPayItemDetailPayStatus, reqData)
              .then(res => {
                nSuccess('操作成功')
                this.getPage()
              })
              .catch(errorHandler('操作失败'))
              .then(() => {
                this.getPage()
              })
          })
          .catch(() => {
            this.getPage()
          })
      },

      // 批量修改免税状态
      batchUpdatePatchHsbz () {
        let reqData = []
        this.selectionArr.map(selection => {
          this.tableData.map(v => {
            if (selection === v.code) {
              for (let i in v) {
                if (v[i] === '--') {
                  v[i] = ''
                }
              }
              let obj = {
                code: v.code,
                hsbz: v.hsbz
              }
              reqData.push(obj)
            }
          })
        })
        if (reqData.length === 0) {
          nError('请选择缴费记录')
          return false
        }
        this.$confirm(`是否确认修改所选中记录的免税状态`, '温馨提示', {
          type: 'info'
        })
          .then(() => {
            this.$axios.post(api.updateOtherPayItemDetailPatchHsbz, reqData)
              .then(res => {
                nSuccess('操作成功')
                this.getPage()
              })
              .catch(errorHandler('操作失败'))
              .then(() => {
                this.getPage()
              })
          })
          .catch(() => {
            this.getPage()
          })
      },

      // 修改置顶状态
      changeSwitch (data) {
        this.$confirm('是否确认修改该免税状态？', '提示')
          .then(() => {
            if (data.hsbzState) {
              data.hsbz = '0'
            } else {
              data.hsbz = '1'
            }
            for (let i in data) {
              if (data[i] === '--') {
                data[i] = ''
              }
            }
            let reqData = {
              code: data.code,
              hsbz: data.hsbz,
            }
            this.$axios.post(api.updateOtherPayItemDetailHsbz, reqData)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(errorHandler('修改失败'))
          })
          .catch(() => {
            this.getPage()
          })
      },

      // 批量生成通知单
      batchDownloadNotice () {
        if (this.selectionArr.length === 0) {
          nError('请先选择对应账单')
          return false
        }
        this.noticeDialogFormVisible = true
        this.getTemplateList()
      },

      // 获取催款单列表
      getTemplateList () {
        this.$axios.get(api.getTemplateList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.noticeTemplateList = data
            }
          })
          .catch(errorHandler('获取催款单失败'))
      },
      // 催款单预览
      previewContract (path, fileName, code) {
        this.downloadNoticeLoading = true
        this.$axios.post(api.createPatchLeaseUrl, {
          billCodes: this.selectionArr,
          fileName: fileName,
          templateUrl: path,
          templateCode: code
        })
          .then(res => {
            this.downloadNoticeLoading = false
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                window.open('http://view.officeapps.live.com/op/view.aspx?src=' + data, '_blank')
              } else {
                nError('预览失败')
              }
            }
          })
          .catch(errorHandler('预览失败'))
          .then(() => {
            this.downloadNoticeLoading = false
          })

      },
      // 催款单生成并下载
      downloadContract (path, fileName, code) {
        this.downloadNoticeLoading = true
        this.$axios.post(api.createPatchLeaseUrl, {
          billCodes: this.selectionArr,
          fileName: fileName,
          templateUrl: path,
          templateCode: code
        })
          .then(res => {
            this.downloadNoticeLoading = false
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data) {
                window.open(data, '_blank')
              } else {
                nError('地址无效')
              }
            }
          })
          .catch(errorHandler('生成失败'))
          .then(() => {
            this.downloadNoticeLoading = false
          })
      },

      // 分账
      separateAccounts (data) {
        console.log(data)
        this.currentBillData = data
        this.dialogVisible = true
      },
      // 取消分账
      cancelSplitAccount () {
        this.currentBillData = {}
        this.dialogVisible = false
      },
      // 确定分账
      confirmSplitAccount () {
        if (!this.splitAccountCount) {
          nError('请输入分期数')
          return false
        }
        if (this.splitAccountCount < 2) {
          nError('分期数必须大于2')
          return false
        }
        let separateAccountDataState = true
        this.separateAccountData.map((v, i) => {
          if (!v.payMoney || !v.payDeadline) {
            separateAccountDataState = false
            nError('请输入完整分期信息')
            return false
          }
          if (i < this.separateAccountData.length - 1) {
            if (Date.parse(v.payDeadline) > Date.parse(this.separateAccountData[i + 1].payDeadline)) {
              separateAccountDataState = false
              nError('后一期截止日期应晚于前一期')
              return false
            }
          }
        })
        if (!separateAccountDataState) {
          return false
        } else {
          this.$axios.post(api.splitAccount, this.separateAccountData)
            .then(res => {
              this.separateAccountData = []
              this.currentBillData = {}
              this.splitAccountCount = null
              this.dialogVisible = false
              nSuccess('分账成功')
              this.getPage()
            })
            .catch(errorHandler('分账失败'))
        }
      },
    },
    watch: {
      payDeadStatus (val) {
        if (val === '1') {
          this.payDeadAppendText = '天外'
        } else if (val === '2') {
          this.payDeadAppendText = '天内'
        }
      },
      timevalue (val) {
        this.getPage()
      },
      payTimevalue (val) {
        this.getPage()
      },
      splitAccountCount (val) {
        let count = +val
        let separateAccountData = []
        for (let i = 0; i < count; i++) {
          let obj = {
            parentCode: this.currentBillData.code,
            enterpriseName: this.currentBillData.enterpriseName,
            enterpriseCode: this.currentBillData.enterpriseCode,
            contractCode: this.currentBillData.contractCode,
            payMoney: '',
            payDeadline: ''
          }
          separateAccountData.push(obj)
        }
        this.separateAccountData = separateAccountData
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less" scoped>
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .el-dialog__header {
    text-align: left;
  }
  .payDeadInput {
    .el-input__inner {
      padding-right: 0;
    }
  }
  .el-input-group__prepend{
    padding: 0 !important;
  }
  .prependSelect {
    width: 80px;
    .el-input__suffix {
      right: 12px;
    }
    .el-input__inner {
      padding: 0 30px 0 20px;
    }
  }
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
  .contractDialogForm {
    .el-dialog__header {
      text-align: center;
    }
    .operationBox {
      span {
        cursor: pointer;
        color: #337ab7;
      }
      span:hover {
        color: #00A0E6;
      }
    }
    .contractDialogLine {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      line-height: 30px;
      padding: 0 15px;
    }
    .contractDialogLine:hover {
      background-color: #eeeeee;
    }
  }
  /deep/ .all-table-class .el-table .cell {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/OtherContracts/OtherRentFinance.vue